import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "./components/cafe/Navbar";
import { Hero } from "./components/cafe/Hero";
import { Marquee } from "./components/cafe/Marquee";
import { Story } from "./components/cafe/Story";
import { Specialities } from "./components/cafe/Specialities";
import { MenuSection } from "./components/cafe/MenuSection";
import { Review } from "./components/cafe/Review";
import { Visit } from "./components/cafe/Visit";
import { Footer } from "./components/cafe/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    const onClick = (event) => {
      const anchor = event.target.closest('a[href^="#"]');
      if (!anchor) return;
      const id = anchor.getAttribute("href");
      if (id.length > 1 && document.querySelector(id)) {
        event.preventDefault();
        lenis.scrollTo(id, { offset: -70, duration: 1.4 });
      }
    };
    document.addEventListener("click", onClick);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      document.removeEventListener("click", onClick);
    };
  }, []);

  return (
    <main className="min-h-screen bg-onyx text-cream" data-testid="app-shell">
      <div className="noise-overlay" aria-hidden="true" />
      <Navbar />
      <Hero />
      <Marquee />
      <Story />
      <Specialities />
      <MenuSection />
      <Review />
      <Visit />
      <Footer />
    </main>
  );
}

export default App;
